// extracted by mini-css-extract-plugin
module.exports = {"root":"TaskWithPopover_root__3hxAD","task":"TaskWithPopover_task__2RC_R"};